// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import { Image } from './Image'
import { Video } from './Video'
import { connect } from '../../lib/provider'
import type { SampleProps } from '../types'
import { sanitizeNames } from '../../lib/sanitizeNames.js'
import styles from './Result.css'

type Props = {
  sendGaEvent: Object => void,
  isFinished: boolean,
  resultSample: SampleProps,
  selfId: string,
  dynamicBaseUrl: string,
  shareHost: string,
  shareConfig: string,
  rootElement: HTMLElement,
  resultText: string
}

export class _Result extends PureComponent<Props, {}> {
  componentDidUpdate = (): void => {
    const { isFinished, rootElement, resultSample } = this.props
    if (isFinished) {
      let mediaDetails
      if (resultSample.media.type === 'picture') {
        mediaDetails = {
          picture: `https://nrk.no/serum/api/imagecrop/${resultSample.media.id}?cropid=f169w900&quality=0.7`,
          credit: resultSample.media.credit,
          creators: resultSample.media.creators
        }
      }
      const event = new CustomEvent('result', {
        detail: {
          ...resultSample,
          mediaDetails
        }
      })
      rootElement.dispatchEvent(event)
    }
  }

  render() {
    const {
      selfId,
      resultSample,
      isFinished,
      dynamicBaseUrl,
      shareHost,
      shareConfig,
      rootElement,
      resultText
    } = this.props
    const { text, name = '', media } = resultSample

    let shareUrl = ''
    if (typeof window !== 'undefined' && typeof resultSample.name !== 'undefined') {
      const sanitizedName = sanitizeNames(name)
      const metadataUrl = `https://dh.nrk.no/personlighetstest/v1/api/share/${selfId}/${encodeURIComponent(
        sanitizedName
      )}`
      const redirectUrl = (window.location && window.location.href) || ''
      const shareApiUrl = `https://${shareHost}/api/dele/v2/share`
      const shareConfigParam = shareConfig !== 'default' ? `&c=${encodeURIComponent(shareConfig)}` : ''
      const shareUrlParam = encodeURIComponent(
        `${shareApiUrl}?r=${encodeURIComponent(redirectUrl)}&m=${encodeURIComponent(metadataUrl)}${shareConfigParam}`
      )
      shareUrl = `https://www.facebook.com/sharer.php?u=${shareUrlParam}`
    }

    const title = resultText.replace('*utvalg*', name.trim())

    return (
      <div className={`${styles['result-text__body']}`}>
        {!isFinished ? (
          <p>Du må svare på alle spørsmålene først.</p>
        ) : (
          <div>
            <h2 className={`${styles['result-title']}`}>{title}</h2>
            {media.type === 'video' ? (
              <Video media={media} gaPropertyId={rootElement.getAttribute('data-ga-property-id')} />
            ) : (
              <Image image={{ id: media.id }} isDynamic dynamicBaseUrl={dynamicBaseUrl} />
            )}
            <div className={`${styles['result-text']}`} dangerouslySetInnerHTML={{ __html: text }} />
            <a
              className={`nrk-button nrk-color-invert ${styles['personalityquiz-share-button']}`}
              target="_blank"
              rel="noopener noreferrer"
              href={shareUrl}
            >
              <svg style="width:1.5em;height:1.5em" focusable="false" aria-hidden="true">
                <use xlinkHref="#nrk-some-facebook" />
              </svg>
              <span>Del ditt resultat på facebook</span>
            </a>
          </div>
        )}
      </div>
    )
  }
}

const connector = connect()
export const Result = connector(_Result)



// WEBPACK FOOTER //
// ./src/v1/components/Result.js